import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LogoTPN from 'assets/images/uploads/tpn_semnatura.png';
import LogoTwispay from 'assets/images/uploads/twispay_logo_dark.svg';
import AnpcFigure1 from 'assets/images/uploads/anpc_figure_1.png';
import AnpcFigure2 from 'assets/images/uploads/anpc_figure_2.png';
import React from 'react';

const Footer = () => {
    const currentYear = new Date().getFullYear();
    const { t } = useTranslation();
    return (
        <footer className='bg-footer footer'>
            <div className='container-fluid text-white'>
                <Row>
                    <Col className={'mt-2'}>
                        <Row>
                            <Col>Copyright 2019 - {currentYear} © Platforma-De.INFO</Col>
                        </Row>
                        <Row>
                            <Col>Toate drepturile rezervate TPN LABS S.R.L</Col>
                        </Row>
                        <Row>
                            <Col>
                                C.U.I. 47826085 | J35/1136/2023
                                {' | '}
                                <Link to='/pages/termeni-si-conditii' className={'p-0'}>
                                    {t('footer.terms_and_conditions')}
                                </Link>
                                {' | '}
                                <Link to='/pages/termeni-si-conditii' className={'p-0'}>
                                    {t('footer.privacy_policy')}
                                </Link>
                                {' | '}
                                <Link to='/pages/termeni-si-conditii' className={'p-0'}>
                                    {t('footer.cookie_policy')}
                                </Link>
                            </Col>
                        </Row>
                    </Col>
                    <Col className={'mt-2'}>
                        <Row>
                            <Col className={'d-flex align-items-center justify-content-center'}>
                                <Link to={'https://anpc.ro/ce-este-sal/'}>
                                    <img src={AnpcFigure1} alt='Ce este SAL' style={{ height: 50, width: 'auto' }} />
                                </Link>
                            </Col>
                        </Row>
                        <Row className={'mt-2'}>
                            <Col className={'d-flex align-items-center justify-content-center'}>
                                <Link to={'https://ec.europa.eu/consumers/odr/main/index.cfm'}>
                                    <img src={AnpcFigure2} alt='EU ODR' style={{ height: 50, width: 'auto' }} />
                                </Link>
                            </Col>
                        </Row>
                    </Col>
                    <Col className={'mt-2'}>
                        <Row>
                            <Col className={'d-flex align-items-center justify-content-center'}>
                                <img src={LogoTwispay} alt='Logo Twispay' height='50' />
                            </Col>
                        </Row>
                        <Row>
                            <Col className={'d-flex align-items-center justify-content-center'}>
                                <a href='https://tpn-labs.com' target='_blank' rel='noreferrer'>
                                    <img src={LogoTPN} alt='Logo TPN LABS' height='60' />
                                </a>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </footer>
    );
};

export default Footer;
